<template>
    <div class="usermanagement">
        <md-dialog-alert
            :md-content="alert.content"
            :md-ok-text="alert.ok"
            ref="alert" >
        </md-dialog-alert>

        <div class="users-main">
            <div class="datatable-wrapper">
                <wb-data-table
                    @addEmit="addNewUser"
                    @editEmit="editEmit"
                    @changeEmit="watchUserInput"
                    @deleteEmit="removeEmit"
                    v-bind="userDataTableProperties">

                    <template v-for="column in tableColumns" :slot="column.slotName" slot-scope="{ row }">
                        <slot v-if="column.slotName" :name="column.slotName" :row="row">

                        </slot>
                    </template>

                </wb-data-table>
            </div>
            <md-button class="userTableButton"
                       v-show="addUserAllowed || (!newUser.hasConsoleAccess && newUser.hasProgrammaticAccess)"
                       :disabled="!addUserAllowed && !(!newUser.hasConsoleAccess && newUser.hasProgrammaticAccess)"
                       @click="addUser">
                <slot name="addButton"></slot>
            </md-button>
            <p class="error-msg">{{validationErrorMsg}}</p>
        </div>

        <md-dialog class="usermanagement-dialog sidebar-dialog" ref="edit-user">
            <md-dialog-title>
                <div><slot name="changeRole"></slot></div>
                <md-icon @click.native="closeDialog('edit-user')">clear</md-icon>
            </md-dialog-title>

            <md-dialog-content>
                <div class="sidebar-content">

                    <div v-if="programmaticAccess" class="custom-input-block">
                        <md-input-container>
                            <label for="name"><slot name="nameLabel"></slot></label>
                            <md-input name="name" id="name" v-model="entity.name">
                            </md-input>
                        </md-input-container>
                    </div>

                    <div class="custom-input-block">
                        <md-input-container>
                            <label for="role"><slot name="roleLabel"></slot></label>
                            <md-select name="role" id="role" v-model="entity.role">
                                <md-option v-for="role in getRoles" :value="role.id" :key="role.id">{{role.name}}</md-option>
                            </md-select>
                        </md-input-container>
                    </div>

                    <div v-if="programmaticAccess" class="custom-input-block">
                        <md-input-container>
                            <label for="description"><slot name="descLabel"></slot></label>
                            <md-input name="description" id="description" v-model="entity.description">
                            </md-input>
                        </md-input-container>
                    </div>

                    <div class="btns-container">
                        <md-button @click="closeDialog('edit-user')">Cancel</md-button>
                        <md-button class="primary" @click="submit()">Save</md-button>
                    </div>
                </div>
            </md-dialog-content>
        </md-dialog>

        <md-dialog class="usermanagement-dialog" ref="remove-user">
            <md-dialog-title>
                Are you sure you would like to remove this user?
            </md-dialog-title>

            <md-dialog-content>

            </md-dialog-content>

            <md-dialog-actions>
                <md-button @click="closeDialog('remove-user')">Cancel</md-button>
                <md-button @click="deleteUser()">Ok</md-button>
            </md-dialog-actions>
        </md-dialog>

    </div>
</template>

<script>
    import wbDataTable from 'WBDataTable';
    let managedata = require('./helpers/managedata.js');
    export default {
        name: 'UserManagement',
        components: {
            wbDataTable
        },
        props: {
            allowCreation: Boolean,
            disallowEditing: Boolean,
            isUsersByTeam: Boolean,
            appId: {
                required: false,
                default: 0,
            },
            teamId: {
                required: false,
                default: 0,
            },
            includeAllowed: {
                required: false,
                default: false,
                type: Boolean,
            },
            appIdsForAdditionalRoles: { required: false },
            tableColumns: { required: true, default: [], },
            roles: { required: true, default: [], },
            adminRoles: { required: true, default: [], },
            localization: { required: true,
                validator(value) {
                    return value.alertOk
                        && value.addWarning
                        && value.deleteWarning
                        && value.tableName;
                }
            },
            columnsToValidate: { required: false, default: [], },
            remoteIndex: { default: 2, },
            customCoreUrl: { required: false, default: null, }
        },
        data: () => ({
            alfaAppId: 30,
            validationErrorMsg: null,
            addUserAllowed: false,
            showAddButton: false,
            newUser: {},
            users: [],
            currentUser: null,
            alert: {
                content: 'content',
                ok: 'Ok',
            },
            entity: {
                userId: null,
                role: '',
                password: null,
                hasConsoleAccess: true,
                hasProgrammaticAccess : false,
                name: '',
                description: ''
            },
            userDataTableProperties: {
                dataext: [],
                dataList0: [],
                indentHeight: "300",
                columns: [],
                tableName: 'Users',
                hasControls: true,
                showTitle: true,
                height: '40vh',
                hasFilter: false,
                allowCreation: false
            },
            userToRemove: {},
            programmaticAccess: false,
        }),
        computed: {
            getRoles() {
                let data = this.currentUser && this.currentUser.role === 'admin' ? this.adminRoles : this.roles;
                this.userDataTableProperties.dataList0 = data;
                return data;
            },
        },
        watch: {
            newUser: {
                handler: function (val, oldVal) {
                    this.addUserAllowedFunc();
                },
                deep: true
            }
        },
        methods: {
            addUserAllowedFunc() {
                if ( !this.newUser.email || (this.newUser.email && this.newUser.email === '') || (this.newUser.email && this.newUser.email.length > 0 &&  (!this.newUser.hasConsoleAccess && !this.newUser.hasProgrammaticAccess))) {
                    this.addUserAllowed = false;
                    this.validationErrorMsg = null;
                    return;
                }
                managedata.checkUserEmail(this.remoteIndex, this.newUser.email).then(res => {
                    if (res.body) {
                        this.addUserAllowed = true;
                        this.validationErrorMsg = null;
                    } else {
                        this.addUserAllowed = false;
                        this.validationErrorMsg = 'User with this email already exist';
                    }
                }).catch(err => {
                    this.validationErrorMsg = null;
                    if (this.columnsToValidate.length) {
                        this.addUserAllowed = this.newUser && this.columnsToValidate.reduce((alloc, cur) => alloc && !!this.newUser[cur], true) && this.showAddButton;
                    } else {
                        this.addUserAllowed = this.newUser && this.newUser.username && this.newUser.email && this.showAddButton;
                    }
                });
            },
            getUser() {
                managedata.getRole(this.remoteIndex, this.appId)
                    .then(res => {
                        this.currentUser = res.data;
                        this.loadUsers();
                    })
                    .catch(err => {

                    });
            },
            editEmit(row) {
                this.entity = {
                    userId: row.id,
                    role: row.role,
                    password: undefined,
                    hasConsoleAccess: row.hasConsoleAccess,
                    hasProgrammaticAccess: row.hasProgrammaticAccess,
                    name: row.name,
                    description: undefined,
                }

                const isProgrammaticUser = row.hasProgrammaticAccess && row.hasConsoleAccess === false;
                if (isProgrammaticUser) {
                  this.programmaticAccess = true;
                  if (row.metaData && row.metaData.description) {
                    this.entity.description = row.metaData.description
                  }
                } else {
                  this.programmaticAccess = false;
                  this.entity.name = undefined;
                }

                this.openDialog('edit-user');
            },
            getAllUserAssignments(userId) {
                return managedata.getAllUserRoles(this.remoteIndex, userId);
            },
            submit() {
                let userId = this.entity.userId;
                let role = this.entity.role;
                let name = this.entity.name;
                let description = this.entity.description;

                let promiseName = '';
                if (name || description) {
                    promiseName = managedata.updateUser(this.remoteIndex, userId, name, description)
                }

                let promiseRole = '';
                if (role) {
                    let user = this.users.find(u => u.id === userId);
                    promiseRole = managedata.updateRole(this.remoteIndex, userId, role, this.appId);
                }

                Promise.all([promiseName, promiseRole])
                    .then(() => {
                        this.loadUsers();
                    })
                    .catch(err => {
                        console.log("err: ", err);
                    });

                this.closeDialog('edit-user');
            },
            watchUserInput(row, column) {
                this.newUser = row;
            },
            loadUsers() {
                if (!this.isUsersByTeam && this.appId) {
                    managedata.getUsersByApp(this.remoteIndex, this.appId)
                        .then(res => {
                            this.users = res.data;
                            this.userDataTableProperties.dataext = this.users;
                            this.$nextTick(() => {
                                this.users.forEach((user) => {
                                    if (user.role === 'admin' && this.currentUser.role != 'admin') {
                                        const queryString = `[data-target="${user.id}"]`;
                                        document.querySelector(queryString).querySelector('td:last-child div').remove();
                                    }
                                });
                            });
                        })
                        .catch(err => {
                            console.log(err);
                        });
                } else if (this.isUsersByTeam && this.teamId) {
                    managedata.getUsersByTeam(this.remoteIndex, this.appId, this.includeAllowed)
                        .then(res => {
                            this.users = res.data.map(user => {
                                if (user.appAssignments && user.appAssignments.length) {
                                    user.role = user.appAssignments.find(i => i.role && i.appId == this.appId);
                                    if (user.role) {
                                        user.role = user.role.role;
                                    }
                                }
                                return user;
                            });
                            this.$nextTick(() => {
                                this.userDataTableProperties.dataext = this.users;
                            })
                        })
                        .catch(err => {
                            console.log('err', err)
                        });
                }
            },
            addNewUser() {
                this.showAddButton = true;
                this.newUser = {isNewUser: true, name: "", email: "", role: "client", hasConsoleAccess: true, hasProgrammaticAccess: false};

                this.userDataTableProperties.dataext = [this.newUser].concat(this.users);
            },
            addUser() {
                if (!this.isUsersByTeam) {
                    managedata.addUser(this.remoteIndex, this.appId, this.newUser, this.newUser.role)
                        .then(() => {
                            this.loadUsers();
                            this.showAddButton = false;
                            this.addUserAllowed = false;
                            this.newUser = {};
                        })
                        .catch(err => {
                            let errMsg;
                            if (err && err.body && err.body.error && err.body.error.message) {
                                errMsg = ': ' + err.body.error.message;
                            }
                            this.alert.content = `${this.localization.addWarning}${errMsg}`;
                            this.alert.ok = this.localization.alertOk;
                            this.$refs['alert'].open();
                        });
                } else {
                    if (this.appId !== this.alfaAppId) {
                        managedata.addUserToTeam(this.remoteIndex, this.teamId, this.newUser.name, this.newUser.email, this.newUser.role, this.appId, this.newUser.hasConsoleAccess, this.newUser.hasProgrammaticAccess, `${window.location.origin}/#/password-set?`)
                            .then(result => {
                                if (this.appIdsForAdditionalRoles) {
                                    const userId = result.body.id;
                                    managedata.addAdditionalRoles(this.remoteIndex, userId, this.newUser.role, this.appIdsForAdditionalRoles).then(() => {
                                        this.loadUsers();
                                        this.showAddButton = false;
                                        this.addUserAllowed = false;
                                        this.newUser = {};
                                    }).catch(err => {
                                        let errMsg;
                                        if (err && err.body && err.body.error && err.body.error.message) {
                                            errMsg = ': ' + err.body.error.message;
                                        }
                                        this.alert.content = `${this.localization.addWarning}${errMsg}`;
                                        this.alert.ok = this.localization.alertOk;
                                        this.$refs['alert'].open();
                                    });
                                } else {
                                    this.loadUsers();
                                    this.showAddButton = false;
                                    this.addUserAllowed = false;
                                    this.newUser = {};
                                }
                            })
                            .catch(err => {
                                let errMsg;
                                if (err && err.body && err.body.error && err.body.error.message) {
                                    errMsg = ': ' + err.body.error.message;
                                }
                                this.alert.content = `${this.localization.addWarning}${errMsg}`;
                                this.alert.ok = this.localization.alertOk;
                                this.$refs['alert'].open();
                            });
                    }
                }

            },
            removeEmit(row) {
                this.userToRemove = row;
                this.openDialog('remove-user');
            },
            deleteUser() {
                if (this.currentUser.userid == this.userToRemove.id) {
                    this.alert.content = this.localization.deleteWarning;
                    this.alert.ok = this.localization.alertOk;
                    this.$refs['alert'].open();
                } else {
                    managedata.deleteUser(this.remoteIndex, this.userToRemove.id)
                        .then(() => {
                            this.closeDialog('remove-user');
                            this.userToRemove = {};
                            this.loadUsers();
                        })
                        .catch(err => {

                        });
                }

            },
            openDialog(ref) {
                this.$refs[ref].open();
            },
            closeDialog(ref) {
                this.$refs[ref].close();
            }
        },
        mounted() {
            this.getUser();
            this.userDataTableProperties.disallowEditing = this.disallowEditing;
            this.userDataTableProperties.columns = this.tableColumns;
            this.userDataTableProperties.tableName = this.localization.tableName;
            this.userDataTableProperties.allowCreation = this.allowCreation;
        },
        created() {
            if(this.customCoreUrl) {
                managedata.apiUrl = this.customCoreUrl;
            }
        }
    }

</script>

<style scope>
    .error-msg {
        margin: 10px 0;
        text-align: center;
        color: #c35151;
        text-transform: uppercase;
        font-size: 12px;
    }
</style>
<style>
    .userTableButton {
        background: #6aa924 !important;
        color: #ffffff !important;
    }

    .usermanagement {
        width: 100%;
        height: 100%;
    }
    ::-webkit-scrollbar {
        width: 7px;
    }

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
        border-radius: 1px;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 1px;
        /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);*/
        background: #4a90e2;

    }
    .datatable .md-table-row .table-edit-column {
        width: 70px !important;
    }
</style>
